import Dao from '@/dao/dao';
import _ from 'underscore';
import { Traveler, Trip, Airport } from '@/model/travel';

export class TravelDao extends Dao {
  async getTravelPolicy() {
    try {
      const url = `travel/policy?rev=${this.getRev()}`;
      const { data: policy } = await this.api.get(url);
      return policy;
    } catch (err) {
      console.error(err);
      const message = `Error loading travel policy: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async saveTravelPolicy(policy) {
    try {
      await this.api.post('travel/policy', [policy]);
    } catch (err) {
      console.error(err);
      const message = `Error processing travel policy: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async getPendingTravelers() {
    try {
      const url = `travel/pending?ref=${this.getRev()}`;
      const { data: travelers } = await this.api.get(url);
      return travelers.map(Traveler.create);
    } catch (err) {
      console.error(err);
      const message = `Error loading pending travelers: ${data.err.message}`;
      throw new Error(message);
    }
  }

  async getPendingTrips(userId) {
    try {
      const url = `travel/last/${userId}?rev=${this.getRev()}`;
      const { data: trips } = await this.api.get(url);
      return trips.map(Trip.create);
    } catch (err) {
      console.error(err);
      const message = `Error loading pending trips: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async getAirports() {
    try {
      const url = `travel/airports?ref=${this.getRev()}`;
      const { data: airports } = await this.api.get(url);
      return airports.map(Airport.create);
    } catch (err) {
      console.error(err);
      const message = `Error loading airports ${err.data.message}`;
      throw new Error(message);
    }
  }

  async saveTrip(tripToSave) {
    try {
      const { data: savedTrip } = await this.api.post('travel/trip', tripToSave);
      return Trip.create(savedTrip);
    } catch (err) {
      console.error(err);
      const message = `Error processing trip: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async cancelTrip(trip) {
    try {
      const { data: deleted } = await this.api.delete(`travel/trip/${trip.id}`);
      if (!deleted) {
        throw new Error('Unknown error');
      }
      return deleted;
    } catch (err) {
      console.error(err);
      const message = `Error cancelling trip: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async getTrips(userId) {
    try {
      const { data: trips } = await this.api.get(`travel/trips/${userId}?rev=${this.getRev()}`);
      return trips.map(Trip.create);
    } catch (err) {
      console.error(err);
      const message = `Error loading trips: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async undeclineTravel(registrationId) {
    try {
      const { data: trip } = await this.api.post(`/travel/undecline/${registrationId}`);
      return Trip.create(trip);
    } catch (err) {
      console.error(err);
      const message = `Error loading trips: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async saveTravelerInfo(traveler) {
    try {
      const { data: saved } = await this.api.post('/travel/traveler/info', traveler);
      return saved;
    } catch (err) {
      console.error(err);
      const message = `Error saving Traveler Information: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async saveDormRooms(tripId, dormRooms) {
    try {
      const { data: saved } = await this.api.post(`/travel/dorm/stays/${tripId}`, dormRooms);
      return saved;
    } catch (err) {
      console.error(err);
      const message = `Error saving Dorm Rooms: ${err.data.message}`;
      throw new Error(message);
    }
  }

  async saveAirfare(tripId, flightRequests) {
    try {
      const { data: saved } = await this.api.post(`/travel/airfare/${tripId}`, flightRequests);
      return saved;
    } catch (err) {
      console.error(err);
      const message = `Error saving Airfare: ${err.data.message}`;
      throw new Error(message);
    }
  }
}

const travelDao = new TravelDao();
export default travelDao;
